export const storageKey = {
  USER: 'user',
  REMEMBER_CREDENTIALS: 'remember_credentials',
  EMAIL: 'email',
  CREDIT_PROFILE: 'credit_profile'
}

export const signUpTabs = {
  EMAIL: 'tabs-email-tab',
  CEL: 'tabs-cel-tab'
}

export const loginFieldsRegex = {
  EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  NUMERIC: /^\d*$/
}

export const emailValidation = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

export const passwordValidation = {
  lowercase: /[a-z]/,
  uppercase: /[A-Z]/,
  number: /\d/,
  min: /.{8,}/
}
